import {
  ForwardedRef,
  forwardRef,
  useCallback,
  useImperativeHandle,
  useState,
} from 'react'
import { styled, Typography } from '@mui/material'
import { ExclamationMarkIcon } from '@weblite/icons'
import { t } from '$i18n'
import { PrimaryButton } from '$common/buttons'
import { VerificationSession } from '$logic/auth'
import { PrimaryOutlinedButton } from '$common/buttons/primary-outlined-button'
import { ContentContainer, TextWrapper, IconWrapper } from './shared'
import { initDeleteAccount } from '$logic/client-user'

export interface RequestOtpFormApi {
  sendOtp: (phone: string) => Promise<VerificationSession | undefined>
}
export const RequestOtpForm = forwardRef(function SendOtpFormComponent(
  { onCancel }: { onCancel: () => unknown },
  ref: ForwardedRef<RequestOtpFormApi>,
) {
  const [loading, setLoading] = useState(false)

  const sendOtp = useCallback(async () => {
    try {
      setLoading(true)
      const verificationSession = await initDeleteAccount()
      setLoading(false)
      return verificationSession
    } catch (e) {
      setLoading(false)
      return undefined
    }
  }, [])

  useImperativeHandle(ref, () => ({ sendOtp }), [sendOtp])

  return (
    <>
      <ContentContainer>
        <IconWrapper sx={{ width: '100px', height: '100px' }}>
          <ExclamationMarkIcon
            sx={{ width: '48px', height: '48px', color: 'error500' }}
          />
        </IconWrapper>

        <TextWrapper>
          <Typography variant="h3" color="neutral1000" textAlign="center">
            {t('settings.deleteAccount.title')}
          </Typography>
          <Typography variant="subtitle3" color="neutral700" textAlign="center">
            {t('settings.deleteAccount.description')}
          </Typography>
        </TextWrapper>
      </ContentContainer>
      <ButtonsContainer>
        <PrimaryOutlinedButton
          text={t('common.cancel')}
          onClick={onCancel}
          sx={{ width: 'calc(50% - 6px)' }}
        />
        <PrimaryButton
          text={t('settings.deleteAccount.confirm')}
          type="submit"
          loading={loading}
          sx={{ width: 'calc(50% - 6px)' }}
        />
      </ButtonsContainer>
    </>
  )
})

const ButtonsContainer = styled('div')`
  height: 88px;
  width: 100%;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  bottom: 0;
  left: 0;
`
